import React from 'react';

interface ProcessingIndicatorProps {
  status?: string;
  progress?: number;
  queuePosition?: number;
  content?: string;
}

const ProcessingIndicator: React.FC<ProcessingIndicatorProps> = ({ 
  status, 
  progress, 
  queuePosition,
  content,
}) => {
  const getStatusText = () => {
    if (status === 'queued') return 'Queued for processing';
    if (content && content !== 'Processing your document...') return content;
    return 'Classifying product…';
  };

  return (
    <div className="flex items-center gap-3">
      <div className="w-5 h-5 border-[1.5px] border-teal-600 border-t-transparent rounded-full animate-spin flex-shrink-0" />
      <div className="flex-1">
        <div className="text-sm text-gray-800 font-medium">
          {getStatusText()}
        </div>
        {queuePosition !== undefined && queuePosition > 0 && (
          <div className="text-[11px] text-gray-500 mt-0.5">
            Position in queue: {queuePosition}
          </div>
        )}
        {progress !== undefined && progress > 0 && (
          <div className="mt-2">
            <div className="w-full bg-gray-100 rounded-full h-1.5">
              <div 
                className="bg-teal-600 h-1.5 rounded-full transition-all duration-500"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="text-[10px] text-gray-400 mt-1 tabular-nums">{progress}%</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProcessingIndicator;
